import { z } from "zod";
/**
 * The platform system prompt a super-admin edits, and its history. See
 * `apps/backend/src/modules/system/services/platform_prompt.service.ts`.
 */
/**
 * The ceiling is the cost argument, not a storage limit: this text rides on
 * every request of every call, and a prompt this long has stopped being a
 * set of conduct rules. An agent's own prompt is capped at 20 000.
 */
export const PLATFORM_PROMPT_MAX_CHARS = 4_000;
export const platformPromptVersionZod = z.object({
    id: z.string(),
    text: z.string(),
    createdByUserId: z.string().nullable(),
    /** Null when the user has since been deleted, or for the seeded default. */
    createdByEmail: z.string().nullable(),
    createdAt: z.number(),
});
export const platformPromptStateZod = z.object({
    /** Null on a deployment that has never been seeded. */
    current: platformPromptVersionZod.nullable(),
    /** Newest first, the current one included. */
    versions: z.array(platformPromptVersionZod),
    /** The text a fresh deployment starts with, for "reset to default". */
    defaultText: z.string(),
});
/** Empty is allowed and means "no platform prompt": the layer switched off. */
export const platformPromptSaveInputZod = z.object({
    text: z.string().max(PLATFORM_PROMPT_MAX_CHARS),
});
//# sourceMappingURL=platform_prompt.zod.js.map